/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc
 */
import * as References from './MarketplaceInstallsRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc#getInstallCount
 */
export const GET_INSTALL_COUNT_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsRpc_getInstallCount';
export const GET_INSTALL_COUNT_QUERY: RegisteredQuery<
  'result',
  References.GetInstallCountRequestType,
  References.GetInstallCountResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_INSTALL_COUNT_QUERY_FIELD_NAME,
  args: ['listingId', 'slug'],
  fetcher(
    request: References.GetInstallCountRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetInstallCountResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getInstallCountRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc#getInstallCountBatch
 */
export const GET_INSTALL_COUNT_BATCH_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsRpc_getInstallCountBatch';
export const GET_INSTALL_COUNT_BATCH_QUERY: RegisteredQuery<
  'result',
  References.GetInstallCountBatchRequestType,
  References.GetInstallCountBatchResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_INSTALL_COUNT_BATCH_QUERY_FIELD_NAME,
  args: ['listingIds', 'slugs'],
  fetcher(
    request: References.GetInstallCountBatchRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetInstallCountBatchResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getInstallCountBatchRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc#sendInstallIntent
 */
export const SEND_INSTALL_INTENT_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsRpc_sendInstallIntent';
export const SEND_INSTALL_INTENT_QUERY: RegisteredQuery<
  'result',
  References.SendInstallIntentRequestType,
  References.SendInstallIntentResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: SEND_INSTALL_INTENT_QUERY_FIELD_NAME,
  args: ['slug'],
  fetcher(
    request: References.SendInstallIntentRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SendInstallIntentResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.sendInstallIntentRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc#getInstallCompatibility
 */
export const GET_INSTALL_COMPATIBILITY_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsRpc_getInstallCompatibility';
export const GET_INSTALL_COMPATIBILITY_QUERY: RegisteredQuery<
  'result',
  References.GetInstallCompatibilityRequestType,
  References.GetInstallCompatibilityResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_INSTALL_COMPATIBILITY_QUERY_FIELD_NAME,
  args: ['listingId', 'published', 'listingLanguage'],
  fetcher(
    request: References.GetInstallCompatibilityRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetInstallCompatibilityResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getInstallCompatibilityRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc#getInstallability
 */
export const GET_INSTALLABILITY_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsRpc_getInstallability';
export const GET_INSTALLABILITY_QUERY: RegisteredQuery<
  'result',
  References.GetInstallabilityRequestType,
  References.GetInstallabilityResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_INSTALLABILITY_QUERY_FIELD_NAME,
  args: ['listingId', 'published', 'listingLanguage'],
  fetcher(
    request: References.GetInstallabilityRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetInstallabilityResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getInstallabilityRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc#getOAuthUrl
 */
export const GET_OAUTH_URL_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsRpc_getOAuthUrl';
export const GET_OAUTH_URL_QUERY: RegisteredQuery<
  'result',
  References.GetOAuthUrlRequestType,
  References.GetOAuthUrlResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_OAUTH_URL_QUERY_FIELD_NAME,
  args: ['listingId', 'published'],
  fetcher(
    request: References.GetOAuthUrlRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetOAuthUrlResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getOAuthUrlRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc#getInstallExemptionStatus
 */
export const GET_INSTALL_EXEMPTION_STATUS_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsRpc_getInstallExemptionStatus';
export const GET_INSTALL_EXEMPTION_STATUS_QUERY: RegisteredQuery<
  'result',
  References.GetInstallExemptionStatusRequestType,
  References.GetInstallExemptionStatusResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_INSTALL_EXEMPTION_STATUS_QUERY_FIELD_NAME,
  args: ['productId'],
  fetcher(
    request: References.GetInstallExemptionStatusRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetInstallExemptionStatusResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getInstallExemptionStatusRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc#getRequiredScopeGroups
 */
export const GET_REQUIRED_SCOPE_GROUPS_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsRpc_getRequiredScopeGroups';
export const GET_REQUIRED_SCOPE_GROUPS_QUERY: RegisteredQuery<
  'result',
  References.GetRequiredScopeGroupsRequestType,
  References.GetRequiredScopeGroupsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_REQUIRED_SCOPE_GROUPS_QUERY_FIELD_NAME,
  args: ['appId', 'listingId'],
  fetcher(
    request: References.GetRequiredScopeGroupsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetRequiredScopeGroupsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getRequiredScopeGroupsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc#checkRequiredScopeGroupsInSync
 */
export const CHECK_REQUIRED_SCOPE_GROUPS_IN_SYNC_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsRpc_checkRequiredScopeGroupsInSync';
export const CHECK_REQUIRED_SCOPE_GROUPS_IN_SYNC_QUERY: RegisteredQuery<
  'result',
  References.CheckRequiredScopeGroupsInSyncRequestType,
  References.CheckRequiredScopeGroupsInSyncResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: CHECK_REQUIRED_SCOPE_GROUPS_IN_SYNC_QUERY_FIELD_NAME,
  args: ['listingVersionId'],
  fetcher(
    request: References.CheckRequiredScopeGroupsInSyncRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CheckRequiredScopeGroupsInSyncResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.checkRequiredScopeGroupsInSyncRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
